import { ChakraProvider, ColorModeScript } from "@chakra-ui/react";
import React from "react";
import ChakraTheme from "./theme/index";

const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <ColorModeScript initialColorMode={"system"} />
      <ChakraProvider theme={ChakraTheme}>{children}</ChakraProvider>
    </>
  );
};

export { ThemeProvider };
